@if ({valueChosen: valueChosen$ | async}; as state) {
  @if (metric?.type === trackerMetricTypes.Numeric || metric?.type === trackerMetricTypes.Text) {
    <div class="numeric-container" [class.text-type]="metric?.type === trackerMetricTypes.Text">
      <oph-input-orange
        [control]="control"
        [inputStyle]="inputStyle"
        [showUpdateButton]="showNumericUpdateButton"
        [type]="metric?.type === trackerMetricTypes.Numeric ? 'number' : 'text'"
        [buttonStyle]="{height: '28px'}"
        [updateButtonStatus]="loadingStatus"
        [showError]="!!validationError()"
        [errorMessage]="validationError()"
        [min]="metric?.min ? +metric.min : undefined"
        [max]="metric?.max ? +metric.max : undefined"
        (update)="onUpdateValue($event)"
        (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"
      ></oph-input-orange>
      @if (suffix) {
        <div class="suffix" [class.suffix-focused]="inputFocused">
          <span>{{ suffix }}</span>
        </div>
      }
    </div>
  }

  @if (metric?.type === trackerMetricTypes.Boolean) {
    <!-- This means it is used in current sked -->
    <oph-button-group
      [options]="booleanOptions"
      [selectedOptionName]="getBooleanSelectedValue()"
      [disabled]="false"
      [buttonStyle]="{padding: '0 5px'}"
      [style]="{'max-width': '166px', height: '36px', 'border-radius': '8px'}"
      (optionClick)="onUpdateValue($event)"
    ></oph-button-group>
    <mat-icon [class.show]="loadingStatus === 'success'" svgIcon="check"></mat-icon>
  }

  @if (metric?.type === trackerMetricTypes.Select) {
    <tracker-detail-metric-select
      [buttonText]="state.valueChosen && control?.value ? control.value : 'Choose'"
      [options]="options || []"
      [buttonStyle]="selectButtonStyle || inputStyle || {height: '40px'}"
      [ngStyle]="selectStyle"
      [loadingStatus]="loadingStatus"
      (optionChange)="onUpdateValue($event)"
    ></tracker-detail-metric-select>
  }

  @if (metric?.type === trackerMetricTypes.Duration) {
    <div class="duration-container" (focusin)="onDurationFocus()" (focusout)="onDurationBlur()">
      <oph-duration-input [control]="control" [durationType]="$any(metric.durationType)"></oph-duration-input>
      @if (showNumericUpdateButton) {
        <button
          class="duration-update-button"
          [class.focused-button]="durationFocused || !!loadingStatus"
          [ngStyle]="buttonStyle || {height: '28px'}"
          [disabled]="!!loadingStatus"
          (click)="onDurationUpdate()"
        >
          @if (loadingStatus === 'loading') {
            <mat-spinner class="custom-color" diameter="20"></mat-spinner>
          } @else if (loadingStatus === 'success') {
            <mat-icon class="white-check show" svgIcon="check"></mat-icon>
          } @else {
            Update
          }
        </button>
      }
    </div>
  }

  @if (metric?.type === trackerMetricTypes.Photo) {
    <div class="photo-container">
      @if (control?.value && control.value.trim()) {
        <div class="photo-preview-container">
          <img
            [src]="control.value"
            [alt]="'Photo for ' + metric?.name"
            class="photo-preview"
            (error)="onPhotoError()"
          />
        </div>
      } @else {
        <div class="photo-empty-container" matTooltip="Updated in Current Sked">
          <span>No image</span>
        </div>
      }
    </div>
  }
}
